<div class="dx-field">
  <div class="dx-field-label w-50">{{ 'Alte udf_NMVARIANTS Featuresystem erzeugen' | translate }}</div>
  <dx-switch [(value)]="mode"></dx-switch>
</div>
<div class="dx-field">
  <div class="dx-field-label w-50">{{ 'udf_NMTECHNICALDETAILS-1.0 erzeugen' | translate }}</div>
  <dx-switch [(value)]="createTechnicalDetails"></dx-switch>
</div>
